import { render, staticRenderFns } from "./TaskCommentMessage.vue?vue&type=template&id=53a8be2d&"
import script from "./TaskCommentMessage.vue?vue&type=script&lang=js&"
export * from "./TaskCommentMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports